const GedFileSearchModel = {
  nome: null,
  // gedTipoID: null,
  // gedAssuntoID: null,
  // gedTagIDs: null,
  empresaID: null
}

export default GedFileSearchModel



// WEBPACK FOOTER //
// ./src/shared/models/business/gedFilesearchmodel.js